import React from 'react'
import { RightArrowContainer, ContainerIcon } from '../styles'
import { ChevronRight } from '@mui/icons-material';
import { Icon } from '@mui/material';

let interval
function RightArrow(props) {
  const { onClick } = props
  React.useEffect(() => {
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [])
  const onHover = () => {
    interval = setInterval(onClick, 900)
  }
  return (
    <RightArrowContainer
      className="w-12"
      onMouseEnter={onHover}
      onMouseLeave={() => {
        if (interval) {
          clearInterval(interval)
        }
      }}
      onClick={onClick}
    >
      <ContainerIcon>
        <Icon component={ChevronRight} fontSize="large" />
      </ContainerIcon>
    </RightArrowContainer>
  )
}

export default React.memo(RightArrow)